<template>
  <div class="my-balance">
    <!-- <div class="my-balance-left">
      <div class="current-balance">
        <div class="title small text-white">{{ $t(`Current Balance`) }}</div>
        <div class="balance-info">
          <div class="img-wrapper">
            <svg
              width="64"
              height="64"
              viewBox="0 0 64 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.6">
                <path
                  d="M45.334 37.3333H45.3607"
                  stroke="white"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18.6667 18.6667H50.6667C52.0812 18.6667 53.4377 19.2286 54.4379 20.2288C55.4381 21.229 56 22.5855 56 24V50.6667C56 52.0812 55.4381 53.4377 54.4379 54.4379C53.4377 55.4381 52.0812 56 50.6667 56H13.3333C11.9188 56 10.5623 55.4381 9.5621 54.4379C8.5619 53.4377 8 52.0812 8 50.6667V13.3333C8 11.9188 8.5619 10.5623 9.5621 9.5621C10.5623 8.5619 11.9188 8 13.3333 8H50.6667"
                  stroke="white"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </svg>
          </div>
          <p class="desc balance-amount">
            {{ user?.balance }}
            <span class="text-red">{{ currencySymbol }}</span>
          </p>
        </div>
        <div class="withdraw-balance">
          <button class="text-yellow desc" @click="openWithdraw()">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.6">
                <path
                  d="M20 5H4C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2 10H22"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </svg>

            <b> {{ $t("Withdraw") }}</b>
          </button>
        </div>
      </div>

      <div class="right">
        <div class="top-up-balance">
          <div class="title small text-white">{{ $t(`Top up balance`) }}</div>
          <div class="amount-selection">
            <h4 class="desc">{{ $t(`Choose amount`) }}</h4>
            <div class="amount-buttons">
              <button
                v-for="amount in amounts"
                :key="amount"
                :class="['amount-btn', { selected: selectedAmount === amount }]"
                @click="selectAmount(amount)"
              >
                {{ amount }} {{ currencySymbol }}
              </button>
            </div>
            <p class="or-text">{{ $t(`or`) }}</p>
            <div class="custom-amount">
              <input
                v-model.number="selectedAmount"
                type="number"
                :placeholder="$t('Enter your amount')"
              />
              <span class="currency">{{ currencySymbol }}</span>
            </div>
          </div>
        </div>
        <div class="payment-summary">
          <div class="bottom">
            <div class="minimum-amount">
              <p class="text desc">
                {{ $t("Minimum top-up amount") }}
                <span class="amount">
                  {{ currencySymbol }}{{ getMinTopupAmount }}
                </span>
              </p>
            </div>
            <button
              @click="openDepositModal"
              class="pay-button button small yellow w-142"
              :disabled="!isValidAmount"
            >
              {{ $t("PAY") }}
            </button>
          </div>
        </div>
      </div>
    </div> -->
    <div class="title small">{{ $t(`Transactions`) }}</div>
    <TransactionHistory />
  </div>

  <teleport to="#app">
    <DepositModal
      v-if="depositModalIsVisible && user"
      :user="user"
      :loader-is-visible="loaderIsVisible"
      :deposit-amount="selectedAmount"
      :payment-type="'card'"
    />
  </teleport>
</template>

<script>
import DepositModal from "@/components/DepositModal.vue";
import { mapActions, mapGetters } from "vuex";
import TransactionHistory from "../tabs/TransactionHistory.vue";
export default {
  components: { DepositModal, TransactionHistory },
  name: "MyBalance",
  props: {
    user: Object,
    minTopupAmount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      amounts: [15, 25, 50, 100, 200],
      selectedAmount: 0,
      cardNumber: "",
      expiryDate: "",
      cvv: "",
      loaderIsVisible: false,
    };
  },
  watch: {},
  computed: {
    ...mapGetters("app", ["currencySymbol", "currencyValue"]),
    ...mapGetters("modals", ["depositModalIsVisible"]),
    getMinTopupAmount() {
      const minTopup = parseFloat(this.minTopupAmount);
      const currencyVal = parseFloat(this.currencyValue);

      // Check if both values are valid numbers
      if (!isNaN(minTopup) && !isNaN(currencyVal) && currencyVal >= 0) {
        return (minTopup * currencyVal).toFixed(2);
      } else {
        return "N/A";
      }
    },
    totalAmount() {
      return parseFloat(this.selectedAmount) || 0.0;
    },
    isValidAmount() {
      const amount = parseFloat(this.selectedAmount);
      return !isNaN(amount) && amount >= 0.01;
    },
  },
  methods: {
    ...mapActions("modals", ["openDepositModal"]),
    selectAmount(amount) {
      this.selectedAmount = amount;
    },

    openWithdraw() {
      this.$emit("openWithdraw");
    },
  },
};
</script>

<style lang="scss" scoped>
.my-balance {
  margin-top: 16px;
  padding: 32px;
  background: #191919;
  border-radius: 12px;
}
.my-balance-left {
  width: 100%;
  display: flex;
}

.current-balance {
  text-align: center;
  position: relative;
  padding: 46px;
  flex: 1;
  border: 1px solid #ffffff1a;
  box-shadow: 0px 12px 24px 0px #0000003d;
  background: #424648;
  border-radius: 24px;
  background-image: url("../../assets/img/balanceBg.webp");
  background-size: cover;
  background-position: center;
}

.wallet-icon-wrapper {
  width: 42px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #15ca5c1a;
  border-radius: 3px;
}

.wallet-icon-wrapper img {
  width: 18px;
  height: 18px;
}
.my-balance-right {
  text-align: center;
}
.current-balance .top {
  display: flex;
  align-items: center;
  gap: 18px;
  z-index: 1;
  position: relative;
}

.current-balance .top h3 {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 18.75px;
  color: white;
  text-transform: uppercase;
}

.balance-amount {
  font-weight: 700;
  font-size: 64px;
  line-height: 150%;
  color: #fff;
  width: 100%;
  text-align: center;
}
.withdraw-balance {
  padding-top: 52px;
  text-align: center;

  .desc {
    gap: 12px;
    display: flex;
    align-items: center;
    margin: 0 auto;
  }
}
.right {
  padding: 46px;
  flex: 1;
}

.top-up-balance {
  flex-grow: 1;
  text-align: center;

  .amount-selection {
    margin-top: 24px;
  }
  h4 {
    line-height: 16px;
    color: #ffffff99;
    line-height: 24px;
    margin-bottom: 16px;
  }
}

.payment-methods {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.payment-method {
  display: flex;
  align-items: center;
}

.balance-info {
  padding: 0;
  width: 100%;
  margin-top: 24px;
  justify-content: center;
  text-align: center;
  line-height: 0;
}
.card-icon {
  width: 24px;
  height: 24px;
  margin-right: 20px;
}

.payment-methods-logos {
  display: flex;
  align-items: center;
  gap: 22px;
}

.payment-method span {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16.41px;
  color: white;
}

.amount-buttons {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;
  align-items: center;
  gap: 20px;
  justify-content: center;
}

.amount-btn {
  height: 40px;
  padding: 10px 8px;
  border: none;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  border: 1px solid #ffffff57;
  background: #24292b;
  color: #fff;
  min-width: 82px;

  cursor: pointer;
  border-radius: 80px;
}

.amount-btn.selected {
  background: #6cc025;
  border: 1px solid #ffffff57;

  color: #24292b;
}

.or-text {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #ffffff99;
  margin-bottom: 20px;
}

.custom-amount {
  position: relative;
  width: 100%;
  max-width: 220px;
  margin: 0 auto;
}

.custom-amount input {
  width: 100%;
  height: 44px;
  padding: 14px 18px;
  background: #2f3436;
  border: 1px solid #ffffff33;
  border-radius: 60px;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  color: #fff;
}

.custom-amount .currency {
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: #b7b8c1;
}

.payment-summary {
  margin-top: 12px;
  width: 100%;
}

.payment-summary .you-get {
  background-color: #151522;
  padding: 24px 24px 56px 24px;
  text-align: center;
  margin-bottom: 19px;
}

.payment-summary h3 {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16.41px;
  color: white;
  margin-bottom: 43px;
}

.total-amount {
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 28.13px;
  color: white;
  margin-bottom: 19px;
}

.minimum-amount {
  display: flex;
  align-items: center;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  gap: 7px;
  color: #b7b8c1;
  text-align: center;

  .text {
    width: 100%;
    color: #ffffff99;
    font-size: 12px;
  }
}

.exclamation-icon {
  height: 14px;
  width: 14px;
}

.wrapper.pay-button-wrapper {
  margin: 0;
}
.pay-button {
  margin: 46px auto 0;
  display: table;
}

.modal {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: #191919;
  padding: 20px;
  border-radius: 6px;
  max-width: 400px;
  width: 100%;
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.form-group label {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: #b7b8c1;
  margin-bottom: 8px;
}

.form-group input {
  height: 44px;
  padding: 14px 18px;
  background-color: #b7b8c11a;
  border: 1px solid #939598;
  border-radius: 6px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: #b7b8c1;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.cancel-btn,
.confirm-btn {
  width: 48%;
  height: 48px;
  border: none;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 14.63px;
  cursor: pointer;
}

.cancel-btn {
  background-color: #b7b8c1;
  color: #191919;
}

.confirm-btn {
  background-color: #15ca5c;
  color: #191919;
}

@media (max-width: 1200px) {
  .my-balance {
    flex-direction: column;
  }
  .my-balance-left {
    width: 100%;
    padding: 0;
    border: 0;
    flex-direction: column;
  }
  .my-balance-right {
    width: 100%;
    margin-top: 40px;
    padding: 0;
  }
  .transaction-history {
    margin-top: 24px;
  }

  .current-balance {
    width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
    padding: 24px 16px;
  }

  .top-up-balance {
    width: 100%;
  }

  .payment-summary {
    width: 100%;
    margin-top: 20px;
  }

  .amount-buttons {
    flex-wrap: wrap;
  }

  .amount-btn {
    margin-bottom: 10px;
  }

  .custom-amount {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .my-balance {
    padding: 20px;
  }
  .right {
    flex-direction: column;
    padding: 24px 16px;
  }
}
</style>
